import styled from "styled-components";

export const Box = styled.div`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  .interDisplay {
    font-family: InterDisplay;
  }
  .defaultText {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
      "Helvetica Neue", Arial, sans-serif;
  }
  body {
    // font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    //   "Helvetica Neue", Arial, sans-serif;
    line-height: 1.6;
    background-color: #f3f4f6;
    color: #1f2937;
    min-height: 100vh;
    padding: 2rem 1rem;
  }

  .wordcounter-container {
    max-width: 1000px;
    margin: 0 auto;
  }

  .wordcounter-container .wordcounter-header {
    text-align: center;
    margin-bottom: 2rem;
  }
  .wordcounter-container p.wordcounter-count {
    margin-bottom: 0 !important;
  }

  .wordcounter-container .wordcounter-header h1 {
    font-size: 2.5rem;
    margin-bottom: 0.5rem;
    color: #111827;
  }

  .wordcounter-container .wordcounter-header p {
    color: #6b7280;
  }

  .wordcounter-container .wordcounter-input-section {
    background: white;
    border-radius: 0.75rem;
    padding: 1.5rem;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
    margin-bottom: 2rem;
  }

  .wordcounter-container .wordcounter-top-bar {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    background-color: #e6f0fa;
    padding: 0.5rem 1rem;
    border-radius: 0.5rem 0.5rem 0 0;
    border-bottom: 1px solid #d1d5db;
    font-size: 1rem;
    font-weight: bold;
    color: #1f2937;
  }

  .wordcounter-container .wordcounter-top-bar span {
    margin-right: 1.5rem;
  }

  #wordcounter-text-input {
    width: 100%;
    height: 250px;
    padding: 1rem;
    border: 1px solid #d1d5db;
    border-radius: 0 0 0.5rem 0.5rem;
    // margin-bottom: 1rem;
    font-size: 1rem;
    resize: vertical;
  }

  #wordcounter-text-input:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);
  }

  .wordcounter-container .wordcounter-clear-btn {
    background-color: #dc2626;
    color: white;
    padding: 0.5rem 1rem;
    border: none;
    border-radius: 0.375rem;
    cursor: pointer;
    font-weight: 500;
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    transition: background-color 0.2s;
  }

  .wordcounter-container .wordcounter-clear-btn:hover {
    background-color: #b91c1c;
  }

  .wordcounter-container .wordcounter-stats-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 1.5rem;
    margin-bottom: 2rem;
  }

  .wordcounter-container .wordcounter-stat-card {
    background: white;
    padding: 1.5rem;
    border-radius: 0.5rem;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  }

  .wordcounter-container .wordcounter-stat-header {
    display: flex;
    align-items: center;
    margin-bottom: 1rem;
    color: #111827;
    font-weight: 600;
    font-size: 1.25rem;
  }

  .wordcounter-container .wordcounter-icon {
    margin-right: 0.5rem;
  }

  .wordcounter-container .wordcounter-stat-content {
    color: #4b5563;
  }

  .wordcounter-container .wordcounter-stat-item {
    margin-bottom: 0.5rem;
  }

  .wordcounter-container .wordcounter-top-words {
    background: white;
    padding: 1.5rem;
    border-radius: 0.5rem;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    margin-bottom: 2rem;
  }

  .wordcounter-container .wordcounter-word-chips {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    gap: 1rem;
    margin-bottom: 1rem;
  }

  .wordcounter-container .wordcounter-word-chip {
    background: #fef3c7;
    padding: 0.75rem;
    border-radius: 0.5rem;
  }
  .wordcounter-container .wordcounter-word-chip .displayFlexBox {
    display: flex;
  }

  .wordcounter-container .wordcounter-word-chip .worldColor {
    font-weight: 500;
    color: #92400e;
    word-break: break-word;
    // display: flex;
    // justify-content: space-between;
  }
  // .wordcounter-container .wordcounter-word-chip p:first-child {
  //   font-weight: 500;
  //   color: #92400e;
  //   display: flex;
  //   justify-content: space-between;
  // }

  .wordcounter-container .wordcounter-word-chip .wordcounter-density {
    font-size: 0.875rem;
    color: #92400e;
    opacity: 0.8;
    margin-left: auto;
  }

  .wordcounter-container .wordcounter-word-chip .wordcounter-count {
    font-size: 0.875rem;
    color: #92400e;
    opacity: 0.8;
  }

  .wordcounter-container .wordcounter-recommendations {
    background: white;
    padding: 1.5rem;
    border-radius: 0.5rem;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  }

  .wordcounter-container .wordcounter-recommendation-item {
    display: flex;
    align-items: flex-start;
    gap: 0.5rem;
    margin-bottom: 0.5rem;
    color: #4b5563;
  }

  .wordcounter-container .wordcounter-keyword-stats {
    margin-top: 1rem;
    padding-top: 1rem;
    border-top: 1px solid #e5e7eb;
    color: #4b5563;
  }

  @media (max-width: 768px) {
    .wordcounter-container .wordcounter-stats-grid {
      grid-template-columns: 1fr;
    }
    .wordcounter-container .wordcounter-input-section {
      padding: 1rem;
    }
    .wordcounter-container .wordcounter-top-words {
      padding: 1rem;
    }
    .wordcounter-container .wordcounter-recommendations {
      padding: 1rem;
    }
  }
`;
